import { EXTENSION_URL } from "../assets/constants";

export const openExtensionStore = () => {
  window.open(EXTENSION_URL, "_blank", "noopener,noreferrer");
};
